import http from "@/utils/request";

const record = {
  accountBookList: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsAccountBook.queryForSelect",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  accountBookEdit: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsAccountBook.editStock",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  accountBookImport: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsAccountBook.importStock",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  accountBookPreview: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsAccountBook.previewStockImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  accountBookQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsAccountBook.queryStockList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  accountBookQueryAll: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsAccountBook.queryStockByItemNos",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  accountBookExport: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsAccountBook.submitStockExportTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  customerStockExport: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsAccountBook.customerStockExportTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default record;
